module.exports = __webpack_public_path__ + "img/am.3f54e9e2.svg";